import React from 'react';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container!);

export async function appRender(render: () => React.ReactElement) {
	root.render(render());
}
